export const API_URL = import.meta.env.VITE_API_URL as string;
export const HUB_URL = import.meta.env.VITE_HUB_URL as string;
export const BUCKET_NAME = import.meta.env.VITE_AWS_S3_BUCKET_NAME as string;
export const DISPLAY_URL = import.meta.env.VITE_DISPLAY_URL as string;
export const GOOGLE_FONT_API_KEY = import.meta.env.VITE_GOOGLE_FONT_API_KEY as string;
export const CLOUDFRONT_URL = import.meta.env.VITE_CLOUDFRONT_URL as string;